import api from '../../../services/api';

const companyService = {
  getAll: () => api.get('/companies'),
  getOne: (id) => api.get(`/companies/${id}`),
  create: (payload) => api.post('/companies', payload),
  update: (id, payload) => api.put(`/companies/${id}`, payload),
  delete: (id) => api.delete(`/companies/${id}`),
};

export default companyService;
